import React from 'react';
import PropTypes from 'prop-types';

import Message from '../common/message/Message';
import {ProgressItem} from './ProgressItem';
import {ProgText} from './ProgText';

import {PROGRESS} from '../../constants/ProgressStates';

const stepContent = {
    [PROGRESS.ACTIVE]: <ProgText code="epic.esport.step2.content" />,
    [PROGRESS.INCOMPLETE]: <ProgText code="epic.esport.step2.incomplete.content" />,
    [PROGRESS.COMPLETE]: <ProgText code="epic.esport.step2.complete.content" />
};

export const Step2 = ({status, ...otherProps}) => {
    return (
        <ProgressItem
            status={status}
            step={2}
            title={<Message fragment code="epic.esport.step2.title" />}
            {...otherProps}
        >
            {stepContent[status]}
        </ProgressItem>
    );
};

Step2.displayName = 'Step2';

Step2.propTypes = {
    status: PropTypes.oneOf(Object.values(PROGRESS))
};
